// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1wmIw","colMaxWidth":"Table_colMaxWidth__3lbJ3"};